<script>
import { computed, watchEffect, toRefs } from "vue";
import { useStore } from "vuex";
import {useLog, useToaster} from "../../../../../../services/hooks";
import { getDateInSeconds } from "../../../../../../helpers/dateHelper";
import { findRequest } from "../../../../../../api/notaries";
import SearchNotarialCaseComponent from "./searchNotarialCase/SearchNotarialCaseComponent.vue";
import NotarialCasesComponent from "./NotarialCasesComponent.vue";
import SearchNotaryComponent from "./searchNotary/SearchNotaryComponent.vue";
import NavigationComponent from "./NavigationComponent.vue";

export default {
  name: 'NotarialCaseComponent',
  components: {
    SearchNotarialCaseComponent,
    NotarialCasesComponent,
    SearchNotaryComponent,
    NavigationComponent
  },
  props: {
    testator: {
      type: Object,
      required: true
    },
    nextStepHandler: {
      type: Function,
      required: true
    },
    prevStepHandler: {
      type: Function,
      required: true
    },
    notarialCases: {
      type: Array,
      required: true
    },
    setNotarialCases: {
      type: Function,
      required: true
    },
    hasTryFoundNotarialCase: {
      type: Boolean,
      required: true
    },
    setHasTryFoundNotarialCase: {
      type: Function,
      required: true
    },
    setIsFoundNotarialCase: {
      type: Function,
      required: true
    },
    clearSearchNotarialStep: {
      type: Function,
      required: true
    },
    loader: {
      type: Function,
      required: true
    },
    setLogNotarialCase: {
      type: Function,
      required: true
    },
    setNotary: {
      type: Function,
      required: true
    },
    clearNotary: {
      type: Function,
      required: true
    },
    setNotarialCaseNumber: {
      type: Function,
      required: true
    },
    notarialCaseNumber: {
      type: String
    },
    notary: {
      type: Object,
      required: true
    },
    setLocalNotaryId: {
      type: Function,
      required: true
    },
    isDataServiceUnavailable: {
      type: Boolean,
      required: true
    },
    setIsDataServiceUnavailable: {
      type: Function,
      required: true
    },
    setNotarialCaseDateDeath: {
      type: Function,
      required: true
    }
  },
  setup(props) {

    const store = useStore();
    const loader = props.loader;
    const { alertError } = useToaster();
    const { name, dateDeath } = toRefs(props.testator);
    const hasTryFoundNotarialCase = computed(() => props.hasTryFoundNotarialCase);
    const clearSearchNotarialStep = props.clearSearchNotarialStep;
    const setHasTryFoundNotarialCase = props.setHasTryFoundNotarialCase;
    const setIsFoundNotarialCase = props.setIsFoundNotarialCase;
    const setNotarialCases = props.setNotarialCases;
    const setLogNotarialCase = props.setLogNotarialCase;
    const clearNotary = props.clearNotary;
    const setNotarialCaseNumber = props.setNotarialCaseNumber;
    const setIsDataServiceUnavailable = props.setIsDataServiceUnavailable;
    const { recordLog } = useLog();

    const isTestatorValidate = () => {

      let hasError = false;
      const currentDate = (new Date()).getTime();

      if(name.value.value === '' || name.value.value === null) {
        name.value.errorText = 'Заполните ФИО наследодателя (по свидетельству о смерти)';
        name.value.hasError = true;
        hasError = true;
      } else {
        name.value.errorText = '';
        name.value.hasError = false;
      }

      if(dateDeath.value.value === '' || dateDeath.value.value === null) {
        dateDeath.value.errorText = 'Заполните дату смерти наследодателя';
        dateDeath.value.hasError = true;
        hasError = true;
      } else {

        const dateField = new Date(dateDeath.value.value);

        if(dateField.getTime() >= currentDate) {
          dateDeath.value.errorText = 'Дата не может быть больше текущей';
          dateDeath.value.hasError = true;
          hasError = true;
        } else {
          dateDeath.value.errorText = '';
          dateDeath.value.hasError = false;
        }
      }

      return !hasError;
    };

    const searchSubmitHandler = () => {

      setTimeout(function () {

        if(isTestatorValidate()) {

          loader(true);
          setIsDataServiceUnavailable(false);
          clearSearchNotarialStep();

          findRequest({
            name: name.value.value,
            date: getDateInSeconds(dateDeath.value.value)
          }).then(response => {

            loader(false);
            setHasTryFoundNotarialCase(true);
            const data = response.data;

            if (!data || !data.data) {
              return;
            }

            const status = data.data.status;
            const result = data.data.result;

            if (status === 1) {
              return;
            }

            if (status === 2) {
              recordLog('Сервис нотариата был недоступен');
              setIsDataServiceUnavailable(true);
              setIsFoundNotarialCase(false);
              return;
            }

            if(result.cases.length) {
              setIsFoundNotarialCase(true);
              setNotarialCases(result.cases);
              recordLog('Нотариальное дело найдено');
            } else {
              setIsFoundNotarialCase(false);
              recordLog('Нотариальное дело не найдено');
            }

            setLogNotarialCase(result.process);

          }).catch(error => {
            loader(false);
            console.log(error);
            alertError('Error!');
          });
        }
      },0);
    };

    const isStepValidate = () => {
      return !!(isTestatorValidate() && hasTryFoundNotarialCase.value);
    }

    const toLocalSearchNotaryAction = (e) => {
      e.preventDefault();
      clearNotary();
      setIsFoundNotarialCase(false);
      setNotarialCaseNumber('');
      setNotarialCases([]);
    }

    watchEffect(() => {
      if (store.state.auth.user) {
        recordLog('Переход к заполнению сведений о наследстве');
      }
    });

    return {
      isTestatorValidate,
      searchSubmitHandler,
      isStepValidate,
      toLocalSearchNotaryAction
    }
  }
}
</script>

<template>
  <div class="step-2">
    <h1>Заполните сведения о наследстве</h1>
    <div class="group-block">
      <search-notarial-case-component
        :testator="testator"
        :search-submit-handler="searchSubmitHandler"
      />
      <div v-if="hasTryFoundNotarialCase" class="result">
        <notarial-cases-component
          v-if="notarialCases.length"
          :set-notary="setNotary"
          :set-notarial-case-number="setNotarialCaseNumber"
          :notarial-cases="notarialCases"
          :to-local-search-notary-action="toLocalSearchNotaryAction"
          :testator="testator"
          :set-notarial-case-date-death="setNotarialCaseDateDeath"
        />
        <search-notary-component v-else
          :notary="notary"
          :is-data-service-unavailable="isDataServiceUnavailable"
          :notarial-case-number="notarialCaseNumber"
          :set-local-notary-id="setLocalNotaryId"
          :set-notarial-case-number="setNotarialCaseNumber"
        />
      </div>
    </div>
    <navigation-component
      :is-step-validate="isStepValidate"
      :prev-step-handler="prevStepHandler"
      :next-step-handler="nextStepHandler"
    />
  </div>
</template>

<style scoped>

.step-2 {
  max-width: 600px;
  margin: 0 auto;
}

.group-block {
  border: 1px solid #c7c7c7;
  padding: 10px;
  border-radius: 5px;
  margin-bottom: 15px;
  position: relative;
}

.result {
  margin-top: 15px;
}

</style>
